import { AbstractProvider } from './AbstractProvider';
import { MemoryProvider } from './MemoryProvider';
import * as AccountApi from '../../../api/accountApi';
import { get } from 'lodash';
import { logEvent } from '../../../utils/env';

export class ApiProvider extends AbstractProvider {

  memoryProvider;

  status;

  initialData;

  constructor(userId) {
    super(userId);
    this.memoryProvider = new MemoryProvider(userId);
    this.status = this.initialize();
  }

  async get(key, defaultValue) {
    const serviceAvailable = await this.status;
    if (this.memoryProvider.has(key) || !serviceAvailable) {
      return this.memoryProvider.get(key, defaultValue);
    }
    const response = await AccountApi.getSetting([key]);
    const value = get(response, key, defaultValue);
    this.memoryProvider.patch(key, value);
    return value;
  }

  getSync(key, defaultValue) {
    return this.memoryProvider.getSync(key, defaultValue);
  }

  async patch(key, value) {
    const serviceAvailable = await this.status;
    let result = true;
    if (serviceAvailable) {
      result = await AccountApi.patchSettings(this.toKeyValuePair(key, value));
    }
    this.memoryProvider.patch(key, value);
    return result;
  }

  async patchObject(object) {
    const serviceAvailable = await this.status;
    let result = true;
    if (serviceAvailable) {
      result = await AccountApi.patchSettings(object);
    }
    this.memoryProvider.patchObject(object);
    return result;
  }

  async initialize() {
    try {
      this.initialData = await AccountApi.getSetting();
      this.memoryProvider.patchObject(this.initialData);
      return true;
    } catch (e) {
      logEvent('UserStoreService.ApiProvider: Api Store unavailable. Use Memory service');
      this.initialData = {};
      return false;
    }
  }

}
